import React from "react"
import { view } from "react-easy-state"
import { isMobile } from "react-device-detect"
import { message } from "antd"

import Header from "components/common/layouts/Header"
import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"
import DoubtList from "components/pages/teachers/doubts/index/DoubtList"

import globalStore from "store"

import DoubtsService from "services/teachers/doubts.service"

class DoubtsIndexPage extends React.Component {
  async componentDidMount() {
    const pageState = globalStore.ui.teachers.doubts.index
    await DoubtsService.index({ pageState })
  }

  renderPageContent() {
    const pageState = globalStore.ui.teachers.doubts.index
    const { doubts, doubtErrors, API_DOUBTS_INDEX_STATUS } = pageState

    if (!API_DOUBTS_INDEX_STATUS) return <ContentLoader />
    if (API_DOUBTS_INDEX_STATUS === "pending") return <ContentLoader />
    if (API_DOUBTS_INDEX_STATUS === "rejected") return <ContentLoadingFailed />

    if (doubtErrors) {
      message.destroy()
      message.error(doubtErrors)
      return
    }

    return <DoubtList doubts={doubts} />
  }

  componentWillUnmount() {
    globalStore.ui.teachers.doubts.index = {}
  }

  render() {
    return (
      <div className={`page doubts-page ${isMobile ? "mobile" : ""}`}>
        <Header />
        <div className="page-content">{this.renderPageContent()}</div>
        <Footer />
      </div>
    )
  }
}

export default view(DoubtsIndexPage)
